/**
 * Класс SearchResult предназначен для возврата результата поиска объектов слоя или, в целом, по карте.
 * @param {object} params - опции конструктора
 * @param params.layerId {string} - идентификатор слоя
 * @param params.layerName {string} - имя слоя (для удобства)
 * @param params.queryGeometry {ol.geom.Geometry} - геометрия запроса (точка клика, область)
 * @param params.dirtyData {ol.Feature} - ответ от взаимодействия
 * @param params.feature {ol.Feature} - ответ от взаимодействия
 * @param params.attributes {object} - атрибуты (без геометрии)
 * @param params.preparedAttributes {array} - атрибуты объекта в виде массива
 * @param params.title {string} - подписываемое свойство объекта
 */
class SearchResult {
    /**
     * Создает экземпляр класса SearchResult
     */
    constructor(params) {
        this.layerId = params.layerId;
        this.layerName = params.layerName;
        this.queryGeometry = params.queryGeometry;
        this.attributes = params.attributes;
        this.geometry = params.geometry;
        this.preparedAttributes = params.preparedAttributes;
        this.dirtyData = params.dirtyData;
        this.feature = params.dirtyData;
        this.score = params.score;
        this.title = params.title;
    }
}

module.exports = SearchResult;